import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AfterViewInit, Component, ElementRef, Injector, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';
import { ConfirmationCodeDto } from '../../../../dto/confirmationCodeDto';
import { UsersService } from '../../../../services/entity/users.service';
import { ToastService } from '@services/toast/toast.service';



@Component({
  selector: 'enter-confirmation-code-dialog-content',
  templateUrl: './enter-confirmation-code-dialog-content.component.html',
  styleUrls: ['./enter-confirmation-code-dialog-content.component.scss']
})
export class EnterConfirmationCodeDialogContentComponent extends AbstractDialogContent  implements AfterViewInit{

  public className = 'EnterConfirmationCodeDialogContentComponent';

  public confirmationCode: ConfirmationCodeDto;
  isConfirmBtnDisabled: boolean = true;
  @ViewChild('confirmationCodeInput') confirmationCodeInput: ElementRef;

  constructor(
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    public dialog: NgbModal,
    public formService: FormService,
    private usersService: UsersService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  ngAfterViewInit() {
    this.confirmationCodeInput.nativeElement.focus();
  }

  onConfimClick() {

    if (!this.isConfirmationCodeValid)
      return;

    this.confirmationCode.code = this.confirmationCodeInput.nativeElement.value;
    this.usersService.isConfirmationCodeValid(this.confirmationCode).subscribe(response =>
    {
      if (response !== true) {
        this.toastService.error("Die Eingabe ist falsch.", 0, true);
        return;
      }

      this.toastService.info("Die Eingabe ist korrekt.", 0, true);
      this.activeModal.close({ status: 'ok', code: this.confirmationCode.code });
    });
  }
  close() {
    this.activeModal.close();
  }
  ngOnDestroy() {
  }

  onInputChange(event: any) {
    this.isConfirmBtnDisabled = !this.isConfirmationCodeValid();
  }

  isConfirmationCodeValid(): boolean {
    return (/^\d+$/).test(this.confirmationCodeInput.nativeElement.value) && this.confirmationCodeInput.nativeElement.value.length === 6
  }
}
